export const BASE_URL = "https://api.mysooq.net/api/";
export const IMAGE_BASE_URL = "https://www.mysooq.net";
